<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";
import BaseDialog from "@/stories/dialogs/BaseDialog.vue";
import emitter from "@/emitter";
import IconCircle from "@/stories/displays/IconCircle/IconCircle.vue";
import SVG from "@/stories/displays/SVG/SVG.vue";

const isVisible = ref(false);

const handleMessage = () => {
  isVisible.value = true;
};

onMounted(() => {
  emitter.on("logoutPrompt", handleMessage);
});

onBeforeUnmount(() => {
  emitter.off("logoutPrompt", handleMessage);
});
</script>

<template>
  <BaseDialog v-if="isVisible">
    <div
      class="overflow-hidden w-full text-center place-items-center laptop:w-[28.125rem] px-6 py-10 flex flex-col text-neutral1000"
    >
      <IconCircle size="lg">
        <SVG icon="fas-triangle-exclamation" width="36" height="36"></SVG>
      </IconCircle>
      <div class="h700 text-center mt-5">
        {{ $t("global.logoutPrompt.title") }}
      </div>
      <div class="b300 mt-3">
        {{ $t("global.logoutPrompt.description") }}
      </div>
    </div>
  </BaseDialog>
</template>
